const About = () => import(/* webpackChunkName: "about" */ '@/pages/about.vue')
const Charts = () =>
  import(/* webpackChunkName: "charts" */ '@/pages/charts.vue')
const Extension = () =>
  import(/* webpackChunkName: "extension" */ '@/pages/extension.vue')
const ExtensionCreate = () =>
  import(/* webpackChunkName: "extension-create" */ '@/pages/extension/create.vue')
const ExtensionRules = () =>
  import(/* webpackChunkName: "extension-rules" */ '@/pages/extension/rules.vue')
const ExtensionId = () =>
  import(/* webpackChunkName: "extension-id" */ '@/pages/extension/_id.vue')
const ExtensionIndex = () =>
  import(/* webpackChunkName: "extension-index" */ '@/pages/extension/index.vue')
const Fields = () =>
  import(/* webpackChunkName: "fields" */ '@/pages/fields.vue')
const FieldsCreate = () =>
  import(/* webpackChunkName: "fields-create" */ '@/pages/fields/create.vue')
const FieldsForm = () =>
  import(/* webpackChunkName: "fields-form" */ '@/pages/fields/form.vue')
const FieldsId = () =>
  import(/* webpackChunkName: "fields-id" */ '@/pages/fields/_id.vue')
const FieldsIndex = () =>
  import(/* webpackChunkName: "fields-index" */ '@/pages/fields/index.vue')
const Filesystem = () =>
  import(/* webpackChunkName: "filesystem" */ '@/pages/filesystem.vue')
const Forgot = () =>
  import(/* webpackChunkName: "forgot" */ '@/pages/forgot.vue')
const Forms = () => import(/* webpackChunkName: "forms" */ '@/pages/forms.vue')
const FormsCreate = () =>
  import(/* webpackChunkName: "forms-create" */ '@/pages/forms/create.vue')
const FormsForm = () =>
  import(/* webpackChunkName: "forms-form" */ '@/pages/forms/form.vue')
const FormsId = () =>
  import(/* webpackChunkName: "forms-id" */ '@/pages/forms/_id.vue')
const FormsIndex = () =>
  import(/* webpackChunkName: "forms-index" */ '@/pages/forms/index.vue')
const Index = () => import(/* webpackChunkName: "index" */ '@/pages/index.vue')
const Login = () => import(/* webpackChunkName: "login" */ '@/pages/login.vue')
const Logs = () => import(/* webpackChunkName: "logs" */ '@/pages/logs.vue')
const Methodics = () =>
  import(/* webpackChunkName: "methodics" */ '@/pages/methodics.vue')
const MethodicsDomain = () =>
  import(/* webpackChunkName: "methodics-domain" */ '@/pages/methodics/domain.vue')
const MethodicsIndex = () =>
  import(/* webpackChunkName: "methodics-index" */ '@/pages/methodics/index.vue')
const Objects = () =>
  import(/* webpackChunkName: "objects" */ '@/pages/objects.vue')
const ObjectsCreate = () =>
  import(/* webpackChunkName: "objects-create" */ '@/pages/objects/create.vue')
const ObjectsForm = () =>
  import(/* webpackChunkName: "objects-form" */ '@/pages/objects/form.vue')
const ObjectsId = () =>
  import(/* webpackChunkName: "objects-id" */ '@/pages/objects/_id.vue')
const ObjectsIndex = () =>
  import(/* webpackChunkName: "objects-index" */ '@/pages/objects/index.vue')
const ObjectsTypeCreate = () =>
  import(/* webpackChunkName: "objects-type-create" */ '@/pages/objects/_type/create.vue')
const ObjectsTypeForm = () =>
  import(/* webpackChunkName: "objects-type-form" */ '@/pages/objects/_type/form.vue')
const ObjectsTypeId = () =>
  import(/* webpackChunkName: "objects-type-id" */ '@/pages/objects/_type/_id.vue')
const ObjectsTypeIndex = () =>
  import(/* webpackChunkName: "objects-type-index" */ '@/pages/objects/_type/index.vue')
const Permissions = () =>
  import(/* webpackChunkName: "permissions" */ '@/pages/permissions.vue')
const Profile = () =>
  import(/* webpackChunkName: "profile" */ '@/pages/profile.vue')
const Sample = () =>
  import(/* webpackChunkName: "sample" */ '@/pages/sample.vue')
const Types = () => import(/* webpackChunkName: "types" */ '@/pages/types.vue')
const TypesCreate = () =>
  import(/* webpackChunkName: "types-create" */ '@/pages/types/create.vue')
const TypesForm = () =>
  import(/* webpackChunkName: "types-form" */ '@/pages/types/form.vue')
const TypesId = () =>
  import(/* webpackChunkName: "types-id" */ '@/pages/types/_id.vue')
const TypesIndex = () =>
  import(/* webpackChunkName: "types-index" */ '@/pages/types/index.vue')
const Users = () => import(/* webpackChunkName: "users" */ '@/pages/users.vue')
const UsersCreate = () =>
  import(/* webpackChunkName: "users-create" */ '@/pages/users/create.vue')
const UsersForm = () =>
  import(/* webpackChunkName: "users-form" */ '@/pages/users/form.vue')
const UsersId = () =>
  import(/* webpackChunkName: "users-id" */ '@/pages/users/_id.vue')
const UsersIndex = () =>
  import(/* webpackChunkName: "users-index" */ '@/pages/users/index.vue')
const MenusCreate = () =>
  import(/* webpackChunkName: "menus-create" */ '@/pages/menus/create.vue')
const MenusForm = () =>
  import(/* webpackChunkName: "menus-form" */ '@/pages/menus/form.vue')
const MenusId = () =>
  import(/* webpackChunkName: "menus-id" */ '@/pages/menus/_id.vue')
const MenusIndex = () =>
  import(/* webpackChunkName: "menus-index" */ '@/pages/menus/index.vue')
const WebsiteForm = () =>
  import(/* webpackChunkName: "website-form" */ '@/pages/website/form.vue')
const WebsiteId = () =>
  import(/* webpackChunkName: "website-id" */ '@/pages/website/_id.vue')

export default [
  {
    name: 'about',
    path: '/about',
    component: About
  },
  {
    name: 'charts',
    path: '/charts',
    component: Charts,
    meta: {
      requiresAuth: true,
      permissions: ['stats']
    }
  },
  {
    name: 'extension',
    path: '/extension',
    component: Extension,
    children: [
      {
        name: 'extension-create',
        path: 'create',
        component: ExtensionCreate
      },
      {
        name: 'extension-rules',
        path: 'rules',
        component: ExtensionRules
      },
      {
        name: 'extension-id',
        path: ':id',
        component: ExtensionId
      },
      {
        name: 'extension-index',
        path: '',
        component: ExtensionIndex
      }
    ]
  },
  {
    name: 'fields',
    path: '/fields',
    component: Fields,
    children: [
      {
        name: 'fields-create',
        path: 'create',
        component: FieldsCreate,
        meta: {
          requiresAuth: true
        }
      },
      {
        name: 'fields-form',
        path: 'form',
        component: FieldsForm
      },
      {
        name: 'fields-id',
        path: ':id',
        component: FieldsId,
        meta: {
          requiresAuth: true
        }
      },
      {
        name: 'fields-index',
        path: '',
        component: FieldsIndex,
        meta: {
          requiresAuth: true
        }
      }
    ]
  },
  {
    name: 'filesystem',
    path: '/filesystem',
    component: Filesystem
  },
  {
    name: 'forgot',
    path: '/forgot',
    component: Forgot
  },
  {
    name: 'forms',
    path: '/forms',
    component: Forms,
    children: [
      {
        name: 'forms-create',
        path: 'create',
        component: FormsCreate,
        meta: {
          requiresAuth: true
        }
      },
      {
        name: 'forms-form',
        path: 'form',
        component: FormsForm
      },
      {
        name: 'forms-id',
        path: ':id',
        component: FormsId,
        meta: {
          requiresAuth: true
        }
      },
      {
        name: 'forms-index',
        path: '',
        component: FormsIndex,
        meta: {
          requiresAuth: true
        }
      }
    ]
  },
  {
    name: 'index',
    path: '/',
    component: Index,
    meta: {
      requiresAuth: true
    }
  },
  {
    name: 'login',
    path: '/login',
    component: Login,
    meta: {
      transitionName: 'fade'
    }
  },
  {
    name: 'logs',
    path: '/logs',
    component: Logs,
    meta: {
      requiresAuth: true
    }
  },
  {
    name: 'methodics',
    path: '/methodics',
    component: Methodics,
    children: [
      {
        name: 'methodics-domain',
        path: 'domain',
        component: MethodicsDomain,
        meta: {
          requiresAuth: true
        }
      },
      {
        name: 'methodics-index',
        path: '',
        component: MethodicsIndex,
        meta: {
          requiresAuth: true
        }
      }
    ]
  },
  {
    name: 'objects',
    path: '/objects',
    component: Objects,
    children: [
      {
        name: 'objects-create',
        path: 'create',
        component: ObjectsCreate,
        meta: {
          requiresAuth: true
        }
      },
      {
        name: 'objects-form',
        path: 'form',
        component: ObjectsForm
      },
      {
        name: 'objects-id',
        path: ':id',
        component: ObjectsId,
        meta: {
          requiresAuth: true
        }
      },
      {
        name: 'objects-index',
        path: '',
        component: ObjectsIndex,
        meta: {
          requiresAuth: true
        }
      },
      {
        name: 'objects-type-create',
        path: ':type/create',
        component: ObjectsTypeCreate,
        meta: {
          requiresAuth: true
        }
      },
      {
        name: 'objects-type-form',
        path: ':type/form',
        component: ObjectsTypeForm
      },
      {
        name: 'objects-type-id',
        path: ':type/:id',
        component: ObjectsTypeId,
        meta: {
          requiresAuth: true
        }
      },
      {
        name: 'objects-type-index',
        path: ':type',
        component: ObjectsTypeIndex,
        meta: {
          requiresAuth: true
        }
      }
    ]
  },
  {
    name: 'permissions',
    path: '/permissions',
    component: Permissions
  },
  {
    name: 'profile',
    path: '/profile',
    component: Profile,
    meta: {
      requiresAuth: true
    }
  },
  {
    name: 'sample',
    path: '/sample',
    component: Sample
  },
  {
    name: 'types',
    path: '/types',
    component: Types,
    children: [
      {
        name: 'types-create',
        path: 'create',
        component: TypesCreate,
        meta: {
          requiresAuth: true
        }
      },
      {
        name: 'types-form',
        path: 'form',
        component: TypesForm
      },
      {
        name: 'types-id',
        path: ':id',
        component: TypesId,
        meta: {
          requiresAuth: true
        }
      },
      {
        name: 'types-index',
        path: '',
        component: TypesIndex,
        meta: {
          requiresAuth: true
        }
      }
    ]
  },
  {
    name: 'users',
    path: '/users',
    component: Users,
    children: [
      {
        name: 'users-create',
        path: 'create',
        component: UsersCreate,
        meta: {
          requiresAuth: true
        }
      },
      {
        name: 'users-form',
        path: 'form',
        component: UsersForm
      },
      {
        name: 'users-id',
        path: ':id',
        component: UsersId,
        meta: {
          requiresAuth: true
        }
      },
      {
        name: 'users-index',
        path: '',
        component: UsersIndex,
        meta: {
          requiresAuth: true
        }
      }
    ]
  },
  {
    name: 'menus-create',
    path: '/menus/create',
    component: MenusCreate,
    meta: {
      requiresAuth: true
    }
  },
  {
    name: 'menus-form',
    path: '/menus/form',
    component: MenusForm
  },
  {
    name: 'menus-id',
    path: '/menus/:id',
    component: MenusId,
    meta: {
      requiresAuth: true
    }
  },
  {
    name: 'menus-index',
    path: '/menus',
    component: MenusIndex,
    meta: {
      requiresAuth: true
    }
  },
  {
    name: 'website-form',
    path: '/website/form',
    component: WebsiteForm
  },
  {
    name: 'website-id',
    path: '/website/:id',
    component: WebsiteId
  }
]
